var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import InlineSVG from 'react-inlinesvg';
import { MUI_ICONS } from './icons';
import { getAccurityIconPath, isValidMuiIcon } from '../utils';
var AccurityIconInner = function (_a, ref) {
    var iconName = _a.iconName, restProps = __rest(_a, ["iconName"]);
    if (isValidMuiIcon(iconName)) {
        var IconComponent = MUI_ICONS[iconName];
        return React.createElement(IconComponent, __assign({}, restProps, { ref: ref }));
    }
    else {
        var iconPath = getAccurityIconPath(iconName);
        if (!iconPath) {
            // this is mistake, notify the developer
            console.log('Missing Icon', iconName);
        }
        return iconPath ? (React.createElement(SvgIcon, __assign({}, restProps, { ref: ref }),
            React.createElement(InlineSVG
            // ignore cls-1 fill: #1d1d1b; set inside some icons
            // remove with removing <Icon /> component and its styles
            , { 
                // ignore cls-1 fill: #1d1d1b; set inside some icons
                // remove with removing <Icon /> component and its styles
                className: "ignore-cls-1", src: iconPath, cacheRequests: true }))) : null;
    }
};
AccurityIconInner.muiName = SvgIcon.muiName;
var AccurityIcon = React.forwardRef(AccurityIconInner);
export default AccurityIcon;
//# sourceMappingURL=AccurityIcon.js.map